import React, { useState } from "react"

import SlotsPickerModal from "../../../inscription/components/SlotsPickerModal"
import SubjectsPickerModal from "../../../inscription/components/SubjectsPickerModal"
import { SharedCourseAdvantagesModal } from "../../../new-subscription/v2/SharedCourseAdvantagesModal"
import { ActivationComposerScreen } from "../../../ports/primary/ui/screens/parent/Activation/ActivationComposerScreen"

/**
 * Composeur de la reprise (`activation/composer`) : l'écran du design system, avec les trois
 * modales qu'il n'a pas portées — la grille de créneaux, le catalogue de matières et le comparatif
 * des formules — montées ICI, en legacy.
 *
 * C'est la règle du contrat des ports : un parcours legacy gardé tel quel s'ouvre depuis le
 * fichier legacy, qui passe l'ouverture en prop. Les ports rendent la CONFIGURATION de la modale
 * (ce qui est déjà choisi, les plafonds) et le rappel de validation ; ce qui en ressort repart
 * dans le brouillon. Le legacy importe les ports, jamais l'inverse.
 *
 * `request` survit à la fermeture le temps de l'animation : le vider tout de suite ferait
 * disparaître la sélection sous les yeux du parent pendant que la modale se referme.
 */
const ActivationComposerWithPickers = ({ route }) => {
    const [slots, setSlots] = useState({ request: null, open: false })
    const [subjects, setSubjects] = useState({ request: null, open: false })
    const [advantagesOpen, setAdvantagesOpen] = useState(false)

    const subjectOptions = (subjects.request?.subjects ?? []).map((subject) => ({
        label: subject.name,
        value: subject.id,
        labelIconImage: subject.icon,
    }))
    const maxSubjects = subjects.request?.maxSubjects ?? null

    return (
        <>
            <ActivationComposerScreen
                route={route}
                onOpenSlots={(request) => setSlots({ request, open: true })}
                onOpenSubjects={(request) => setSubjects({ request, open: true })}
                onOpenOfferInfo={() => setAdvantagesOpen(true)}
            />

            <SlotsPickerModal
                isVisible={slots.open}
                onClose={() => setSlots((current) => ({ ...current, open: false }))}
                onValidate={(validated) => {
                    slots.request?.onValidate(validated)
                    setSlots((current) => ({ ...current, open: false }))
                }}
                initialSlots={slots.request?.slots ?? []}
                includeSunday={!!slots.request?.includeSunday}
                minSlots={1}
                weeklyHours={slots.request?.weeklyHours}
                userTimezone={slots.request?.userTimezone ?? null}
                serverTimezone={slots.request?.serverTimezone ?? null}
                at={slots.request?.at ?? null}
            />

            <SharedCourseAdvantagesModal
                isVisible={advantagesOpen}
                onClose={() => setAdvantagesOpen(false)}
            />

            <SubjectsPickerModal
                isVisible={subjects.open}
                onClose={() => setSubjects((current) => ({ ...current, open: false }))}
                onValidate={(ids) => {
                    subjects.request?.onValidate(ids)
                    setSubjects((current) => ({ ...current, open: false }))
                }}
                options={subjectOptions}
                initialSubjects={subjects.request?.selectedIds ?? []}
                maxSubjects={maxSubjects}
                maxSubjectsLabel={maxSubjects > 0 ? maxSubjects : null}
                homeworkSupportFrom={subjects.request?.homeworkSupportFrom ?? null}
            />
        </>
    )
}

export default ActivationComposerWithPickers
